const apiBaseUrl = process.env.NODE_ENV === "development"
  ? process.env.REACT_APP_API_URL || "http://localhost:5000"
  : "";

export default apiBaseUrl.replace(/\/$/, "");
